import { Form } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React from 'react'
import { InfoModal } from '../common'

const TextInfo = ({ label, name, placeholder, info, max, description }) => {
  return (
    <Form.Item label={label}>
      <Form.Item name={name} noStyle>
        <TextArea
          rows={3}
          maxLength={max}
          showCount={
            description
              ? {
                  formatter: ({ value, count, maxLength }) => {
                    return description.replace('{COUNT}', maxLength - count)
                  },
                }
              : false
          }
          placeholder={placeholder}
        />
      </Form.Item>
      <span className="input-info">
        <InfoModal>{info}</InfoModal>
      </span>
    </Form.Item>
  )
}
export default TextInfo
